import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import { logoFullWhite, logoIconWhite, logoBill } from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import { consultantAndFragmentService, payService } from "api";
import { column, getTodayString } from "./ModalPrintTP.config";
import { useAppSelector } from "redux/hooks";
import moment from "moment";
import "./ModalPrintTP.scss";
import Notification from "components/common/notification/notification";
import { ReactComponent as PhoneSVG } from "assets/icons/phone-svg.svg";
import { ReactComponent as MailSVG } from "assets/icons/mail-svg.svg";
import { ReactComponent as InternetSVG } from "assets/icons/internet-svg.svg";
import {
  birthday2Age,
  convertIosStringToDate,
  formatToCurrencyType,
} from "helper/common";
import { HeaderPrintForm } from "components/common";
import { FORMAT_TIME } from "types/enums";
import { Input } from "antd";
const { Text } = Typography;

const ModalPrintTP = (props) => {
  const { isShowModal, handleOk, handleCancel, dataTable, listICDTP } = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [data, setData] = useState([]);
  const [dataTab, setDataTab] = useState([]);
  const idPhieuKham = useAppSelector((state) => state.common.idPhieuKham);
  const idBh = useAppSelector((state) => state.common.idReceiptPrint);
  const [thanhTien, setThanhTien] = useState();
  const [tongCong, setTongCong] = useState();
  const [tenThuNgan, setTenThuNgan] = useState<any>();
  const onPrint = async () => {
    //  handleCancel();
    window.print();
  };
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const handleCheckboxChange = (rowNumber, checkboxNumber) => {
    // Nếu checkbox đang được chọn, hủy chọn nó
    if (selectedCheckboxes[rowNumber] === checkboxNumber) {
      setSelectedCheckboxes((prevSelectedCheckboxes) => ({
        ...prevSelectedCheckboxes,
        [rowNumber]: null,
      }));
    } else {
      // Nếu checkbox chưa được chọn, chọn nó
      setSelectedCheckboxes((prevSelectedCheckboxes) => ({
        ...prevSelectedCheckboxes,
        [rowNumber]: checkboxNumber,
      }));
    }
  };
  useEffect(() => {
    // Nếu isShowModalM thay đổi, đặt trạng thái của các checkbox về mặc định
    if (isShowModal === true) {
      setSelectedCheckboxes({});
    }
  }, [isShowModal]);
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const convertMatToString = (mat) => {
    switch (mat) {
      case 0:
        return "Mắt trái";
      case 1:
        return "Mắt phải";
      case 2:
        return "Cả 2 mắt";
      case 3:
        return "không xác định mắt";
      default:
        return "";
    }
  };
  const getDateStringLocale = (dateString: string) => {
    const validDate = moment(dateString).isValid();
    if (validDate) {
      const date = moment(dateString);
      const day = date.date();
      const month = date.month() + 1;
      const year = date.year();
      const time = date.format("HH:mm");
      return `${time} Ngày ${day} tháng ${month} năm ${year}`;
    } else {
      return "";
    }
  };
  const handleRemoveDots = (dots: string, value: string) => {
    if (value) {
      //Tách chuỗi
      const newValue = value.split("");
      //Loại bỏ số phần tử ...... bằng với độ dài của chuỗi đã cắt
      const removeDots = dots.slice(newValue.length + 7);
      const joinString = newValue.join("").concat(removeDots);
      return joinString;
    } else return dots;
  };

  return (
    <Row className="exam-reg-bill" style={{ fontSize: "10px" }}>
      <Modal
        wrapClassName="modal-custom-print"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={1000}
      >
        <div className="print-XNTP">
          <div
            ref={printRef}
            className="print-container"
            style={{ paddingTop: "8px" }}
          >
            <Row align={"middle"} justify={"space-between"}>
              <Col flex={"auto"}>
                <Row justify={"start"}>
                  <div
                    style={{
                      padding: "10px",
                      border: "1px solid black",
                      marginLeft: "20px",
                    }}
                  >
                    <img
                      className="img-logo"
                      src={logoBill}
                      style={{ height: "70px", margin: "center" }}
                    />
                  </div>
                </Row>
              </Col>
              <Col flex={"auto"}>
                <Row justify={"center"}>
                  <div
                    style={{
                      padding: "10px",
                      border: "1px solid black",
                      //   marginLeft: "60px",
                    }}
                  >
                    <div>
                      <Typography.Text strong style={{ fontSize: "20px" }}>
                        BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                      </Typography.Text>
                    </div>
                    <div>
                      <Typography.Text style={{ margin: "25%" }}>
                        Trao ánh sáng - Tặng cuộc đời
                      </Typography.Text>
                    </div>
                  </div>
                </Row>
              </Col>
              <Col flex={"auto"}>
                <Row justify={"end"}>
                  <div
                    style={{
                      padding: "10px",
                      border: "1px solid black",
                      marginRight: "20px",
                      textAlign: "center",
                    }}
                  >
                    <div>
                      <Typography.Text style={{ fontSize: "16px" }}>
                        Mã người bệnh
                      </Typography.Text>
                      <br />
                      <Typography.Text style={{ fontSize: "16px" }}>
                        {dataTable?.idBenhNhan ?? ""}
                      </Typography.Text>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row
              style={{
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              <Row justify={"center"}>
                <div
                  style={{
                    fontSize: "30px",
                    fontWeight: "700",
                    paddingTop: "5px",
                  }}
                >
                  PHIẾU YÊU CẦU XÉT NGHIỆM TRUNG MẪU
                </div>
                {dataTable?.ngayNhapVien ? (
                  <Row justify={"center"} style={{ fontSize: "18px" }}>
                    <div>
                      {moment(dataTable?.ngayNhapVien).format(
                        "[Ngày] DD [Tháng] MM [Năm] YYYY"
                      )}
                    </div>
                  </Row>
                ) : (
                  <p>Ngày..........Tháng..........Năm 20.....</p>
                )}
              </Row>
              <Row>
                <Row justify={"space-between"}>
                  <Row>
                    <Col span={15}>
                      <Typography.Text
                        style={{ fontSize: "13pt" }}
                      >{`- Họ tên người bệnh:   ${
                        dataTable?.hoTen ?? ""
                      }`}</Typography.Text>
                    </Col>
                    <Col span={4}>
                      <Typography.Text style={{ fontSize: "13pt" }}>{`Tuổi: ${
                        dataTable?.ngaySinh
                          ? birthday2Age(dataTable?.ngaySinh)
                          : "--"
                      }`}</Typography.Text>
                    </Col>
                    <Col span={4}>
                      <Typography.Text style={{ fontSize: "13pt" }}>{`${
                        gioiTinhOptions.find(
                          (it) => it.value === dataTable?.gioiTinh ?? null
                        )?.label || ""
                      }`}</Typography.Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={15}>
                      <Typography.Text
                        style={{ fontSize: "13pt" }}
                      >{`- Địa chỉ:   ${
                        dataTable?.diaChiTongHop ?? ""
                      }`}</Typography.Text>
                    </Col>
                    {/* <Col span={6}>
                      <Typography.Text
                        style={{ fontSize: "13pt" }}
                      >{`Điện thoại:   ${
                        dataTable?.dienThoai ?? ""
                      }`}</Typography.Text>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col span={4}>
                      <Typography.Text style={{ fontSize: "13pt" }}>
                        - Chẩn đoán:&nbsp;{" "}
                      </Typography.Text>
                    </Col>
                    <Col flex={"auto"}>
                      {listICDTP?.length > 0
                        ? listICDTP?.map((item) => (
                            <Row
                              className="nameChanDoan"
                              style={{ fontSize: "13pt" }}
                            >
                              {item.maIcd} - {item.tenIcd}
                            </Row>
                          ))
                        : "" || (
                            <Row
                              className="nameChanDoan"
                              style={{ fontSize: "13pt" }}
                            >
                              {listICDTP?.maIcd} - {listICDTP?.tenIcd}
                            </Row>
                          )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <Typography.Text style={{ fontSize: "13pt" }}>
                        - Chỉ định phẫu thuật:&nbsp;{" "}
                      </Typography.Text>
                    </Col>
                    <Col flex={"auto"}>
                      <span style={{ fontSize: "13pt" }}>Mắt phải </span>
                      <input
                        type="checkbox"
                        checked={selectedCheckboxes[99] === 1}
                        onChange={() => handleCheckboxChange(99, 1)}
                        style={{
                          transform: "scale(1.5)",
                          margin: "5px",
                        }}
                      />
                      <span style={{ fontSize: "13pt" }}>/</span>
                      <span style={{ fontSize: "13pt" }}>Mắt trái </span>
                      <input
                        type="checkbox"
                        checked={selectedCheckboxes[100] === 1}
                        onChange={() => handleCheckboxChange(100, 1)}
                        style={{
                          transform: "scale(1.5)",
                          margin: "5px",
                        }}
                      />
                    </Col>
                  </Row>
                </Row>
              </Row>
              <Row style={{ marginTop: "5px" }}>
                <table className="checklist-table">
                  <tr>
                    <th style={{ textAlign: "center" }}>STT</th>
                    <th style={{ textAlign: "center" }}>Tên xét nghiệm</th>
                    <th style={{ textAlign: "center" }}>Đã thực hiện</th>
                    <th style={{ textAlign: "center" }}>Ghi chú</th>
                  </tr>
                  <tr>
                    <td>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          style={{
                            transform: "scale(1.5)",
                            margin: "5px",
                            marginLeft: "15px",
                          }}
                          //disabled
                          checked={selectedCheckboxes[1] === 1}
                          onChange={() => handleCheckboxChange(1, 1)}
                        />
                        <span></span>
                      </label>
                    </td>
                    <td className="category-header" colSpan={3}>
                      TƯ VẤN
                    </td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      1
                    </td>
                    <td>Đã thanh toán</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[18] === 1}
                          onChange={() => handleCheckboxChange(18, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      2
                    </td>
                    <td>Bệnh lý toàn thân</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[2] === 1}
                          onChange={() => handleCheckboxChange(2, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      3
                    </td>
                    <td>Thuốc trước PT</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[3] === 1}
                          onChange={() => handleCheckboxChange(3, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //  disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      4
                    </td>
                    <td></td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" height={20}></td>
                    <td></td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          style={{
                            transform: "scale(1.5)",
                            margin: "5px",
                            marginLeft: "15px",
                          }}
                          // disabled
                          checked={selectedCheckboxes[4] === 1}
                          onChange={() => handleCheckboxChange(4, 1)}
                        />
                        <span></span>
                      </label>
                    </td>
                    <td className="category-header" colSpan={3}>
                      ĐIỀU DƯỠNG
                    </td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      6
                    </td>
                    <td>Huyết áp( &lt;170/90mmHg)</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[5] === 1}
                          onChange={() => handleCheckboxChange(5, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          // disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      7
                    </td>
                    <td>Nhãn áp( &lt;21 mmHg) </td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[6] === 1}
                          onChange={() => handleCheckboxChange(6, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //  disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      rowSpan={2}
                      style={{ textAlign: "center" }}
                    >
                      8
                    </td>
                    <td>Bơm kiểm tra lệ đạo</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[7] === 1}
                          onChange={() => handleCheckboxChange(7, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //  disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Roplas( - )</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[8] === 1}
                          onChange={() => handleCheckboxChange(8, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          // disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      9
                    </td>
                    <td>Đường huyết(RBS)(&lt;11mmol/L)</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      10
                    </td>
                    <td>ECG</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" height={20}></td>
                    <td></td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          style={{
                            transform: "scale(1.5)",
                            margin: "5px",
                            marginLeft: "15px",
                          }}
                          // disabled
                          checked={selectedCheckboxes[9] === 1}
                          onChange={() => handleCheckboxChange(9, 1)}
                        />
                        <span></span>
                      </label>
                    </td>
                    <td className="category-header" colSpan={3}>
                      XÉT NGHIỆM MÁU
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      style={{ textAlign: "center" }}
                    ></td>
                    <td>Tổng phân tích tế bào máu ngoại vi</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[10] === 1}
                          onChange={() => handleCheckboxChange(10, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          // disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      style={{ textAlign: "center" }}
                    ></td>
                    <td>Thời gian prothrompin</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[11] === 1}
                          onChange={() => handleCheckboxChange(11, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //   disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      style={{ textAlign: "center" }}
                    ></td>
                    <td>Thời gian thromboplastin một phần hoạt hóa</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[12] === 1}
                          onChange={() => handleCheckboxChange(12, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //  disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      style={{ textAlign: "center" }}
                    ></td>
                    <td>HIV Ab test nhanh</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[13] === 1}
                          onChange={() => handleCheckboxChange(13, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          // disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td
                      className="centered"
                      style={{ textAlign: "center" }}
                    ></td>
                    <td>HBsAg test nhanh</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[14] === 1}
                          onChange={() => handleCheckboxChange(14, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          // disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="centered" height={20}></td>
                    <td></td>
                    <td className="centered">
                      <label className="custom-checkbox"></label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className="category-header" colSpan={3}>
                      BÁC SĨ KHÁM
                    </td>
                  </tr>
                  <tr>
                    <td className="centered" style={{ textAlign: "center" }}>
                      11
                    </td>
                    <td>Slit lamp photo</td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: "bold" }} colSpan={2}>
                      Nhỏ thuốc kháng sinh trước mổ ( Vigamox/ Cravit)
                    </td>
                    <td className="centered">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedCheckboxes[15] === 1}
                          onChange={() => handleCheckboxChange(15, 1)}
                          style={{ transform: "scale(1.5)", margin: "5px" }}
                          //  disabled
                        />
                        <span></span>
                      </label>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </Row>
              <Row style={{ marginTop: "0px" }}>
                <Row justify={"space-between"}>
                  <Col>
                    <Row justify={"center"}>
                      <Typography.Text style={{ fontSize: "13pt" }}>
                        Bác sĩ xác nhận đã xem kết quả xét nghiệm và xác nhận
                        người bệnh:
                      </Typography.Text>
                    </Row>
                    <Row justify={"start"}>
                      <span className="centered">
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedCheckboxes[16] === 1}
                            onChange={() => handleCheckboxChange(16, 1)}
                            style={{ transform: "scale(1.5)", margin: "5px" }}
                            //  disabled
                          />
                          <span style={{ fontSize: "13pt" }}>
                            Đủ điều kiện để phẫu thuật.
                          </span>
                        </label>
                      </span>
                    </Row>
                    <Row justify={"start"}>
                      <span className="centered">
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedCheckboxes[17] === 1}
                            onChange={() => handleCheckboxChange(17, 1)}
                            style={{ transform: "scale(1.5)", margin: "5px" }}
                            //  disabled
                          />
                          <span style={{ fontSize: "13pt" }}>
                            Không đủ điều kiện để phẫu thuật do..............
                          </span>
                        </label>
                      </span>
                    </Row>
                  </Col>
                  <Col style={{ textAlign: "center" }}>
                    <Row justify={"center"}>
                      <Typography.Text
                        style={{ fontSize: "13pt", marginRight: "50px" }}
                      >
                        Bác sĩ ký
                      </Typography.Text>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text
                        strong
                        style={{
                          fontSize: "13pt",
                          marginRight: "50px",
                          marginTop: "30px",
                        }}
                      >
                        {dataTable?.bacSyKham}
                      </Typography.Text>
                    </Row>
                  </Col>
                </Row>

                <Row></Row>
              </Row>
            </Row>
            {/* </Watermark> */}
          </div>
        </div>
        <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-thanh-toan-don"
            />
          </Space>
        </Row>
      </Modal>
    </Row>
  );
};

export default ModalPrintTP;
